/**
 * Toggle between "New Trip" and "Previous Trips" modes
 */
function TripModeToggle({ mode, onModeChange }) {
  return (
    <div className="flex bg-gray-100 rounded-lg p-0.5">
      <button
        type="button"
        onClick={() => onModeChange('new')}
        className={`flex-1 py-2 px-3 rounded-md text-xs font-medium transition-colors ${
          mode === 'new'
            ? 'bg-white text-gray-900 shadow-sm'
            : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        New Trip
      </button>
      <button
        type="button"
        onClick={() => onModeChange('previous')}
        className={`flex-1 py-2 px-3 rounded-md text-xs font-medium transition-colors ${
          mode === 'previous'
            ? 'bg-white text-gray-900 shadow-sm'
            : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        Previous Trips
      </button>
    </div>
  );
}

export default TripModeToggle;
